// extracted by css-extract-rspack-plugin
export default {"cls1":"Stats-cls1_4gs","cls2":"Stats-cls2_Oq9 Stats-cls1_4gs"};